import React from "react";
import { IDS } from "@/constants/testIds";

const items = [
  "SOLANA",
  "ANCHOR",
  "RUST",
  "EVM",
  "BASE",
  "ARBITRUM",
  "OPTIMISM",
  "FOUNDRY",
  "HARDHAT",
  "WORMHOLE",
  "PYTH",
  "CHAINLINK",
  "JITO",
  "HELIUS",
  "FIREDANCER",
  "ZK-PROOFS",
];

const Marquee = () => {
  return (
    <section
      data-testid={IDS.marquee}
      aria-label="technology marquee"
      className="border-y border-[rgba(0,255,65,0.18)] bg-black/40 overflow-hidden"
    >
      <div className="marquee-track py-4">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {items.map((t, i) => (
              <span
                key={`${dup}-${i}`}
                className="px-8 text-[11px] uppercase tracking-[0.3em] text-zinc-500 flex items-center gap-3"
              >
                <span className="text-[#00FF41]">◆</span> {t}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
